import { Box } from "@mui/material";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TestimonialCard from "../components/Home/TestimonialCard";

const LandingLayout = ({ children }) => (
  <Box sx={{ overflowX: "hidden" }}>
    <Header />
    {children}
    <TestimonialCard />
    <Footer />
  </Box>
);

export default LandingLayout;

